import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY } from '../../../constants/globalConstants'
import { getPermitDataList, getPermitQR } from '../../../redux/actions/PermitListAction'
import { Circles } from 'react-loader-spinner'
import { renderNoResults } from '../../../components/global/NoDataFound'
import { staticStrings } from '../../../constants/staticStrings'
import { errorMessage } from '../../../constants/errorMessage'
import moment from 'moment'
import { getFacilityOpenDays , nextDayCheck , HorurCheck} from '../../../utils/helper'
import { CancelPermit } from '../../../redux/actions/PermitRequestAction'
// import { errorMessages } from '../../../constants/errorMessages'
// import { Link } from 'react-router-dom'

// let moment = require('moment')

function PermitAccount(props) {
    const { dispatch, loader, notify } = props
    const [permitListData, setPermitListData] = useState(EMPTY_ARRAY)
    // const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [displayVehicle, setDisplayVehicle] = useState(false)
    const [downloadQR, setDownloadQR] = useState(false)


    useEffect(() => {
        // setTimeout(
            dispatch(getPermitDataList()).then((res) => {
                if (res) {
                    // const userData = localStorage.getItem('userData')
                    // const userDetails = JSON.parse(userData)
                    // setUserData(userDetails)
                    setPermitListData(res)
                }
            })
            // , 500)

    }, [EMPTY_ARRAY])

    const handleshowVehicle = () => {
        setDisplayVehicle(!displayVehicle)
    }

    const downloadPermitQr = (id, permitAccount) => {
        setDownloadQR(true)
        if(!downloadQR){
            dispatch(getPermitQR(id, permitAccount)).then((res) => {
                setDownloadQR(false)
                if (res?.status && res?.status == 500) {
                    notify('error', errorMessage?.somethingWentWrong)
                }else{
                    notify('success', 'File Downloaded')
                }
            }).catch((err) => {
                setDownloadQR(false)
                notify('error', err ? err?.message ? err?.message : errorMessage?.somethingWentWrong : errorMessage?.somethingWentWrong)
            })
        }
        
    }


    const cancelPermit = (data) => {
        dispatch(CancelPermit(data.id)).then((res) => {
            notify('success', res.msg)
            dispatch(getPermitDataList()).then((res) => {
                if (res) {
                    // const userData = localStorage.getItem('userData')
                    // const userDetails = JSON.parse(userData)
                    // setUserData(userDetails)
                    setPermitListData(res)
                }
            })
        }).catch((err) => {
            console.log(err)
        })
        
    }

    

  

    return (
        loader ? <span className='ms-2 d-flex justify-content-center'><Circles
            height="50"
            width="50"
            color="var(--bs-primary)"
            ariaLabel="circles-loading"
            visible={true}
        /></span> :
            <div>
                <div className="d-flex justify-content-between mb-4">
                    <h4 className="fw-bold">Permit Account </h4>
                    {/* <Link to='/'>
                    <button className="btn btn-success ms-auto"><i className="fa fa-plus"></i> Add</button>
                </Link> */}
                </div>
                {permitListData?.length > 0 ? <ul className="permitList">
                    {permitListData?.map((item, index) => {
                        if (item == null) return null
                        // const is_active = moment(item?.desired_end_date).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
                        return (
                            <li className={item?.is_expired == 0 && item?.cancelled_at == null ? 'active listItem card border-opacity-25' : 'inactive card listItem border-opacity-25'}  key={index}>

                                <div className={item?.is_expired == 0 && item?.cancelled_at == null ? 'card-header border-0 bg-success bg-opacity-10' : 'card-header border-0 bg-danger bg-opacity-10'} >
                                    <div className='d-flex justify-content-between'>
                                        <h5 className='mb-0 fw-bold'>{item?.permit_rate?.name} Plan</h5>
                                        <small className={item?.is_expired == 0 && item?.cancelled_at == null ? 'text-success' : 'text-danger'}><i className='fa fa-circle '></i> {item?.is_expired == 0 && item?.cancelled_at == null ? 'Active' : 'In-active'}</small>
                                    </div>
                                </div>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-sm-12 mb-sm-0 mb-3'>
                                        <h5 className='mb-0 fw-bold text-muted '>{item?.facility?.full_name ? `${item?.facility?.full_name} -` : ''} <span className='h-6 small'>{item?.permit_type_name}</span></h5> 
                                        
                                        <b className='text-muted'>Permit No: </b><span className='text-success fw-bold'>{item?.account_number}</span>
                                        <div className='row'>
                                            <div className='col-6'>
                                                <b className='text-muted'>Start Date: </b><span>{moment(item?.desired_start_date).format('MM/DD/YYYY')} </span> 
                                            </div>
                                            <div className='col-6'>
                                                <b className='text-muted'>End Date: </b><span>{moment(item?.desired_end_date).format('MM/DD/YYYY')} </span> 
                                            </div>
                                        </div>
                                        <div className='row small'>
                                            {item?.permit_rate ? getFacilityOpenDays(item?.permit_rate) ? 
                                                <p className='small m-0'>
                                                    <b>Allowed on - {getFacilityOpenDays(item?.permit_rate)} </b> 
                                                    <span>{`(${moment(item?.permit_rate?.entry_time_begin, 'hh:mm:ss').format('hh:mm A')}-${moment(HorurCheck(item?.permit_rate?.entry_time_end), 'hh:mm:ss').format('hh:mm A')})${nextDayCheck(item?.permit_rate?.entry_time_end)}`}
                                                </span>
                                                </p> : 
                                                <p className='small m-0'>
                                                <b>Allowed between - </b> 
                                                    <span>{`${moment(item?.permit_rate?.entry_time_begin, 'hh:mm:ss').format('hh:mm A')}-${moment(HorurCheck(item?.permit_rate?.entry_time_end), 'hh:mm:ss').format('hh:mm A')}${nextDayCheck(item?.permit_rate?.entry_time_end)}`}
                                                </span></p> 
                                            : null}
                                            
                                        </div>
                                        
                                      
                                        </div>
                                        <div className='col-sm mb-sm-0 mb-3'>
                                         
                                        <table cellSpacing="0px" cellPadding="0">
                                          <tr>
                                                <th className='text-muted d-none'>Driver License No.:</th><td className='px-2'></td> <td className='text-end'>{item?.license_number}</td>
                                                </tr>
                                                {item?.user?.resident_status ? <tr>
                                                <th colSpan="3" className='text-muted d-none'><span className="badge bg-success"> {item?.user?.resident_status}</span></th>
                                                </tr> : <span className='text-muted d-none'>NA</span>}
                                            </table>
                                            {/* <p className='text-muted mb-0  '>{item?.user?.license_number}<br/>  <b>Driving License No.</b></p> */}
                                        </div>
                                        {item?.permit_vehicle && <div className='col-12 col-sm-12 order-sm-1 order-4 mt-sm-0'>
                                            <table className='table mt-3' cellSpacing="0px" cellPadding="0">
                                                <tr>
                                                    {item?.permit_vehicle[0]?.vehicle?.license_plate_number &&  <th className='text-muted border ps-2'>License Plate:</th>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.color &&  <th className='text-muted border ps-2'>Color:</th>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.make &&  <th className='text-muted border ps-2'>Make:</th>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.model &&  <th className='text-muted border ps-2'>Model:</th>
                                                    }
                                                </tr>
                                                <tr>
                                                    {item?.permit_vehicle[0]?.vehicle?.license_plate_number &&  <td className='small border ps-2'>{item?.permit_vehicle[0]?.vehicle?.license_plate_number}</td>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.color &&  <td className='small border ps-2'>{item?.permit_vehicle[0]?.vehicle?.color}</td>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.make &&  <td className='small border ps-2'>{item?.permit_vehicle[0]?.vehicle?.make}</td>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.model &&  <td className='small border ps-2'>{item?.permit_vehicle[0]?.vehicle?.model}</td>
                                                    }
                                                </tr>
                                            </table>
                                            {item?.permit_vehicle?.length > 1 ? <span className='fw-bold text-primary text-decoration-underline cursor' onClick={() => handleshowVehicle()}>{displayVehicle ? 'Hide All' : 'View All'}</span> : null}
                                            
                                        </div>
                                        }
                                        
                                    </div>

                                        
                                    {displayVehicle && <span><hr/>
                                    <b className='text-muted fw-bold'>Vehicles:</b>
                                    <div className='row align-items-center justify-content-between  '>
                                        <div className='col-sm-12 '>
                                            {item?.permit_vehicle && <div className='col-12 col-sm-auto order-sm-1 order-4 mt-sm-0  '>
                                                <table cellSpacing="0px" cellPadding="0" className='table'>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-muted'>License Plate</th> 
                                                            <th className='text-muted'>Color</th> 
                                                            <th className='text-muted'>Make</th> 
                                                            <th className='text-muted'>Model</th> 
                                                        </tr>
                                                    </thead>
                                                {item?.permit_vehicle?.length > 0 &&  item?.permit_vehicle?.map((item, index) => {
                                                return  <tr key={index}>
                                                            <td className='text-start ps-2'>{item?.vehicle?.license_plate_number ? item?.vehicle?.license_plate_number : '-'}</td>
                                                            <td className='text-start ps-2'>{item?.vehicle?.color ? item?.vehicle?.color : '-'}</td>
                                                            <td className='text-start ps-2'>{item?.vehicle?.make ? item?.vehicle?.make : '-'}</td>
                                                            <td className='text-start ps-2'>{item?.vehicle?.model ? item?.vehicle?.model : '-'}</td>
                                                        </tr>
                                                })}
                                                </table>
                                                
                                            </div>
                                            }
                                        </div>
                                    </div></span>}
                                
                                    <hr/>
                                    <div className='col-12 row'>
                                        <div className='col-12'>
                                            <span className='fontsize85'>
                                                <b>Uploaded Documents:</b>
                                            </span>
                                        </div>

                                        {item?.permit_doc?.length > 0 ? 
                                            item?.permit_doc?.map((item, index) => {
                                                return(
                                                    <div className='col-6' key={index}>
                                                        <span className='d-block'>{item?.doc_name}</span>
                                                        <a href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='fw-bold'>View</a>
                                                    </div>
                                                )
                                            })
                                        :   <div className='col-12'>
                                                <span className='fontsize85'>
                                                    N/A
                                                </span>
                                            </div>}
                                        
                                        
                                    </div>
                                    <hr/>
                                    <div className='row align-items-center justify-content-between  '>
                                        <div className='col-sm-4 text-end order-sm-1 order-4 '>
                                            {item?.transaction?.total && <p className='mb-0'><b className='text-muted fw-bold'>Paid: </b> ${item?.transaction?.total}</p>}
                                        </div>
                                        <div className='col-sm-4 '>
                                        {/* <small><b className='text-muted fw-bold'>Valid Till:</b>  <br className='d-block d-sm-none' />{item?.formatted_desired_end_date}</small> */}
                                        <small><b className='text-muted fw-bold'>Disclaimer:</b>  <br className='d-block d-sm-none' />{staticStrings?.rates24}</small>
                                        </div>
                                        <div className='col-sm-4 '>
                                        <small><b className='text-muted fw-bold'>Autorenew Enabled</b> - <br className='d-block d-sm-none' />{item?.user_consent ? item?.user_consent == 1 ? 'Yes' : 'No' : 'Yes'}</small>
                                        </div>
                                    </div>
                                    {((item?.is_expired == 0 && item?.cancelled_at == null) || (item?.user_consent === '1')) && <div className='d-flex justify-content-between'>
                                        {(item?.is_expired == 0 && item?.cancelled_at == null) ? <span>
                                            <button 
                                                className='mt-3 btn btn-primary btn-sm' 
                                                type='button' 
                                                disabled={downloadQR}
                                                onClick={() => downloadPermitQr(item?.id,item?.account_number)}>
                                                    Download QR
                                                </button>
                                        </span> : <span></span>}
                                        {item?.user_consent === '1' && <span>
                                            <button className='mt-3 btn btn-danger btn-sm' onClick={() => cancelPermit(item)}>{/* <i className='fa fa-times'></i>  */}Cancel Auto Renew</button>
                                        </span>}
                                    </div>}
                                    {/* <div>
                                        <small className='text-danger'>{userData?.user?.license_number != item?.license_number ? errorMessages?.licenseAlertMessage : ''}</small>
                                    </div> */}
                                </div>
                            </li>
                        )
                    })}
                </ul> : renderNoResults()}
            </div>
    )
}

PermitAccount.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    notify: PropTypes.func,

}

PermitAccount.defaulProps = {
    dispatch: noop,
    loader: false,
    notify: noop,

}

function mapStateToProps({ permitListReducer }) {
    return {
        loader: permitListReducer?.loader,
    }
}
export default connect(mapStateToProps)(PermitAccount)